import React from "react";
import "./MpaaRatingsItem.scss";
import cs from "classnames";

export const MpaaRatingsItem = ({ name, value }) => {
  return (
    <div className={cs("mpaa-ratings-item")}>
      {name}: {value}
    </div>
  );
};
